(function () {
  function ready(callback) {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', callback);
    } else {
      callback();
    }
  }

  ready(function () {
  var productScript = document.getElementById('StarterPackProductJson');
  if (!productScript) return;

  var product;
  try {
    product = JSON.parse(productScript.textContent);
  } catch (error) {
    return;
  }

  if (typeof product === 'string') {
    fetch('/products/' + encodeURIComponent(product) + '.js')
      .then(function (response) {
        if (!response.ok) throw new Error('Product unavailable');
        return response.json();
      })
      .then(function (fetchedProduct) {
        product = fetchedProduct;
        initializeBuilder();
      })
      .catch(function () {});
    return;
  }

  initializeBuilder();

  function initializeBuilder() {
  var builder = document.querySelector('[data-starter-pack-builder]');
  var defaultSpirit = builder ? (builder.getAttribute('data-default-spirit') || '').trim() : '';
  var giftBoxProperty = builder ? (builder.getAttribute('data-gift-box-property') || 'Included - worth \u00a36') : 'Included - worth \u00a36';
  function builderText(attribute, fallback) {
    if (!builder) return fallback;
    var value = builder.getAttribute(attribute);
    return value || fallback;
  }
  var copy = {
    discountCode: builderText('data-discount-code', 'FREEGIFT'),
    freeGiftPropertyName: builderText('data-free-gift-property-name', '_Free Gift'),
    giftBoxPropertyName: builderText('data-gift-box-property-name', '_Gift Box'),
    offerCodePropertyName: builderText('data-offer-code-property-name', '_Offer Code'),
    engravingSelectedPropertyName: builderText('data-engraving-selected-property-name', '_Engraving Selected'),
    engravingTextPropertyName: builderText('data-engraving-text-property-name', 'Engraving Text'),
    mobileSpiritPlaceholder: builderText('data-mobile-spirit-placeholder', 'Choose your spirit'),
    mobileSpiritMetaPlaceholder: builderText('data-mobile-spirit-meta-placeholder', 'Pick one 70cl bottle'),
    viewAllLabel: builderText('data-view-all-label', 'View all spirits'),
    viewAllText: builderText('data-view-all-text', 'See the full Salford range'),
    engravingSelectedLabel: builderText('data-engraving-selected-label', 'Selected'),
    engravingNotSelectedLabel: builderText('data-engraving-not-selected-label', 'Not selected'),
    engravingSelectedPriceLabel: builderText('data-engraving-selected-price-label', '+ \u00a315'),
    engravingNotSelectedPriceLabel: builderText('data-engraving-not-selected-price-label', '\u00a30'),
    unavailablePriceLabel: builderText('data-unavailable-price-label', 'Unavailable'),
    soldOutText: builderText('data-sold-out-text', 'This combination is sold out'),
    unavailableText: builderText('data-unavailable-text', 'This combination is unavailable'),
    addingLabel: builderText('data-adding-label', 'Adding...'),
    addedLabel: builderText('data-added-label', 'Added. Taking you to cart...'),
    errorLabel: builderText('data-error-label', 'Unable to add this bundle.')
  };

  function isPurchasableVariant(variant) {
    return Boolean(variant);
  }

  var firstVariant = (product.variants || []).find(function (variant) {
    return defaultSpirit && isPurchasableVariant(variant) && variant.option1 === defaultSpirit;
  }) || (product.variants || []).find(function (variant) {
    return isPurchasableVariant(variant);
  }) || (product.variants || [])[0] || {};

  var state = {
    options: [
      firstVariant.option1 || '',
      firstVariant.option2 || '',
      firstVariant.option3 || ''
    ],
    engravingText: '',
    selectedVariant: null,
    adding: false,
    redirecting: false
  };

  var freeGiftDiscount = 1500;

  var mobileCta = document.querySelector('[data-starter-pack-mobile-cta]');
  if (mobileCta && mobileCta.parentElement !== document.body) {
    document.body.appendChild(mobileCta);
  }

  var hero = document.querySelector('[data-starter-pack-hero]');
  var heroMedia = hero ? hero.querySelector('.starter-pack-hero__media') : null;
  var heroMediaPlaceholder = heroMedia ? document.createComment('starter-pack-hero-media-original-position') : null;
  var heroMediaOriginalParent = heroMedia ? heroMedia.parentNode : null;
  var heroMediaOriginalNext = heroMedia ? heroMedia.nextSibling : null;
  var moveHeroMediaOnMobile = hero && hero.getAttribute('data-mobile-media-after-builder') === 'true';
  var mobileLayoutQuery = window.matchMedia ? window.matchMedia('(max-width: 989px)') : null;

  function syncMobileHeroMediaPosition() {
    if (!moveHeroMediaOnMobile || !heroMedia || !heroMediaOriginalParent || !mobileLayoutQuery) return;

    var target = document.querySelector('[data-starter-pack-summary-section]') || builder;
    if (mobileLayoutQuery.matches && target) {
      if (!heroMediaPlaceholder.parentNode) {
        heroMediaOriginalParent.insertBefore(heroMediaPlaceholder, heroMediaOriginalNext);
      }
      if (heroMedia.parentNode !== target.parentNode || heroMedia.previousSibling !== target) {
        target.parentNode.insertBefore(heroMedia, target.nextSibling);
      }
      heroMedia.classList.add('starter-pack-hero__media--mobile-relocated');
    } else if (heroMediaPlaceholder.parentNode) {
      heroMediaPlaceholder.parentNode.insertBefore(heroMedia, heroMediaPlaceholder);
      heroMediaPlaceholder.parentNode.removeChild(heroMediaPlaceholder);
      heroMedia.classList.remove('starter-pack-hero__media--mobile-relocated');
    }
  }

  syncMobileHeroMediaPosition();
  if (mobileLayoutQuery) {
    if (typeof mobileLayoutQuery.addEventListener === 'function') {
      mobileLayoutQuery.addEventListener('change', syncMobileHeroMediaPosition);
    } else if (typeof mobileLayoutQuery.addListener === 'function') {
      mobileLayoutQuery.addListener(syncMobileHeroMediaPosition);
    }
  }

  var spiritDrawer = document.querySelector('[data-starter-pack-spirit-drawer]');
  if (spiritDrawer) {
    var originalSpiritParent = spiritDrawer.parentElement;
    var drawerSpiritList = spiritDrawer.querySelector('.starter-pack-spirit-list');
    if (originalSpiritParent && drawerSpiritList && !originalSpiritParent.querySelector('[data-starter-pack-desktop-spirit-list]')) {
      var desktopSpiritList = drawerSpiritList.cloneNode(true);
      desktopSpiritList.classList.add('starter-pack-desktop-spirit-list');
      desktopSpiritList.setAttribute('data-starter-pack-desktop-spirit-list', '');
      originalSpiritParent.insertBefore(desktopSpiritList, spiritDrawer);
    }
    if (originalSpiritParent && drawerSpiritList && !originalSpiritParent.querySelector('[data-starter-pack-mobile-spirit-rail]')) {
      var mobileSpiritRail = document.createElement('div');
      mobileSpiritRail.className = 'starter-pack-mobile-spirit-rail';
      mobileSpiritRail.setAttribute('data-starter-pack-mobile-spirit-rail', '');
      var featuredSpiritButtons = Array.prototype.slice.call(drawerSpiritList.querySelectorAll('[data-starter-pack-option]')).slice(0, 3);
      featuredSpiritButtons.forEach(function (button) {
        mobileSpiritRail.appendChild(button.cloneNode(true));
      });
      var viewAllButton = document.createElement('button');
      viewAllButton.type = 'button';
      viewAllButton.className = 'starter-pack-mobile-spirit-rail__view-all';
      viewAllButton.setAttribute('data-starter-pack-spirit-open', '');
      viewAllButton.innerHTML = '<span>' + escapeHtml(copy.viewAllLabel) + '</span><small>' + escapeHtml(copy.viewAllText) + '</small>';
      mobileSpiritRail.appendChild(viewAllButton);
      originalSpiritParent.insertBefore(mobileSpiritRail, spiritDrawer);
    }
    if (spiritDrawer.parentElement !== document.body) {
      document.body.appendChild(spiritDrawer);
    }
  }

  var selectors = {
    optionButtons: '[data-starter-pack-option]',
    engravingField: '[data-starter-pack-engraving-field]',
    engravingText: '[data-starter-pack-engraving-text]',
    engravingCount: '[data-starter-pack-engraving-count]',
    variantInput: '[data-starter-pack-variant-id]',
    price: '[data-starter-pack-price]',
    mobilePrice: '[data-starter-pack-mobile-price]',
    mobileSelection: '[data-starter-pack-mobile-selection]',
    comparePrice: '[data-starter-pack-compare-price]',
    availability: '[data-starter-pack-availability]',
    savings: '[data-starter-pack-savings]',
    spiritSummary: '[data-starter-pack-summary-spirit]',
    spiritSummaryMedia: '[data-starter-pack-summary-spirit-media]',
    giftSummary: '[data-starter-pack-summary-gift]',
    giftSummaryMedia: '[data-starter-pack-summary-gift-media]',
    engravingSummary: '[data-starter-pack-summary-engraving]',
    spiritSummaryPrice: '[data-starter-pack-summary-spirit-price]',
    engravingSummaryPrice: '[data-starter-pack-summary-engraving-price]',
    mobileSpiritMedia: '[data-starter-pack-mobile-spirit-media]',
    mobileSpiritTitle: '[data-starter-pack-mobile-spirit-title]',
    mobileSpiritMeta: '[data-starter-pack-mobile-spirit-meta]',
    mobileSpiritNote: '[data-starter-pack-mobile-spirit-note]',
    mobileSpiritTags: '[data-starter-pack-mobile-spirit-tags]',
    mobileSpiritPrice: '[data-starter-pack-mobile-spirit-price]',
    mobileSpiritCompare: '[data-starter-pack-mobile-spirit-compare]',
    spiritDrawer: '[data-starter-pack-spirit-drawer]',
    spiritOpen: '[data-starter-pack-spirit-open]',
    spiritClose: '[data-starter-pack-spirit-close]',
    addButton: '[data-starter-pack-add]',
    mobileAddButton: '[data-starter-pack-mobile-add]',
    form: '[data-starter-pack-form]',
    message: '[data-starter-pack-message]'
  };

  function money(cents) {
    if (window.Shopify && typeof window.Shopify.formatMoney === 'function') {
      return window.Shopify.formatMoney(cents);
    }
    return new Intl.NumberFormat('en-GB', {
      style: 'currency',
      currency: 'GBP'
    }).format((cents || 0) / 100);
  }

  function isEngravingSelected() {
    var engraving = String(state.options[2] || '').toLowerCase();
    return (engraving.indexOf('yes') !== -1 || engraving.indexOf('with') !== -1) &&
      engraving.indexOf('no') === -1 &&
      engraving.indexOf('without') === -1;
  }

  function isNoEngravingValue(value) {
    var engraving = String(value || '').toLowerCase();
    return engraving.indexOf('no') !== -1 || engraving.indexOf('without') !== -1;
  }

  function matchingVariant() {
    return (product.variants || []).find(function (variant) {
      return variant.option1 === state.options[0] &&
        variant.option2 === state.options[1] &&
        variant.option3 === state.options[2];
    });
  }

  function variantForOption(index, value) {
    var options = state.options.slice();
    options[index] = value;

    return (product.variants || []).find(function (variant) {
      return variant.option1 === options[0] &&
        variant.option2 === options[1] &&
        variant.option3 === options[2];
    });
  }

  function matchingBaseVariant() {
    return (product.variants || []).find(function (variant) {
      return variant.option1 === state.options[0] &&
        variant.option2 === state.options[1] &&
        isNoEngravingValue(variant.option3);
    }) || state.selectedVariant;
  }

  function setText(selector, text) {
    document.querySelectorAll(selector).forEach(function (element) {
      element.textContent = text;
    });
  }

  function escapeHtml(text) {
    return String(text || '')
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#39;');
  }

  function setDisabled(selector, disabled) {
    document.querySelectorAll(selector).forEach(function (element) {
      element.disabled = disabled;
      element.setAttribute('aria-disabled', disabled ? 'true' : 'false');
    });
  }

  function setAddButtonState(isAdding) {
    document.querySelectorAll(selectors.addButton + ', ' + selectors.mobileAddButton).forEach(function (button) {
      if (!button.dataset.starterPackOriginalLabel) {
        button.dataset.starterPackOriginalLabel = button.innerHTML;
      }
      button.setAttribute('aria-busy', isAdding ? 'true' : 'false');
      button.classList.toggle('is-adding', isAdding);
      button.innerHTML = isAdding ? copy.addingLabel : button.dataset.starterPackOriginalLabel;
    });
  }

  function selectedButton(index) {
    return document.querySelector('[data-starter-pack-option][data-option-index="' + index + '"][aria-selected="true"]');
  }

  function setSummaryImage(selector, imageUrl, fallback) {
    document.querySelectorAll(selector).forEach(function (element) {
      if (imageUrl) {
        element.innerHTML = '<img src="' + imageUrl + '" alt="" loading="lazy">';
      } else {
        element.innerHTML = fallback;
      }
    });
  }

  var preloadedFeatureImages = {};

  function preloadFeatureImage(url) {
    if (!url || preloadedFeatureImages[url]) return;
    preloadedFeatureImages[url] = true;
    var image = new Image();
    image.decoding = 'async';
    image.src = url;
  }

  function preloadAllFeatureImages() {
    var buttons = Array.prototype.slice.call(document.querySelectorAll('[data-starter-pack-option][data-option-index="0"]'));
    var urls = [];
    buttons.forEach(function (button) {
      var url = button.getAttribute('data-feature-image');
      if (url && urls.indexOf(url) === -1) {
        urls.push(url);
      }
    });

    urls.slice(0, 2).forEach(preloadFeatureImage);

    var preloadRest = function () {
      urls.slice(2).forEach(preloadFeatureImage);
    };

    if ('requestIdleCallback' in window) {
      window.requestIdleCallback(preloadRest, { timeout: 1800 });
    } else {
      window.setTimeout(preloadRest, 700);
    }
  }

  function setSpiritTags(tags) {
    document.querySelectorAll(selectors.mobileSpiritTags).forEach(function (element) {
      var tagList = (tags || '').split('|').map(function (tag) {
        return tag.trim();
      }).filter(Boolean);
      element.innerHTML = tagList.map(function (tag) {
        return '<span>' + escapeHtml(tag) + '</span>';
      }).join('');
    });
  }

  function updateMobileSpiritTrigger() {
    var button = selectedButton(0);
    if (!button) return;
    var imageUrl = button.getAttribute('data-feature-image') || button.getAttribute('data-summary-image') || '';
    preloadFeatureImage(imageUrl);
    var media = document.querySelector(selectors.mobileSpiritMedia);
    if (media) {
      media.innerHTML = imageUrl ? '<img src="' + imageUrl + '" alt="" loading="lazy">' : '';
    }
    setText(selectors.mobileSpiritTitle, button.getAttribute('data-spirit-title') || state.options[0] || copy.mobileSpiritPlaceholder);
    setText(selectors.mobileSpiritMeta, button.getAttribute('data-spirit-meta') || copy.mobileSpiritMetaPlaceholder);
    setText(selectors.mobileSpiritNote, button.getAttribute('data-spirit-note') || '');
    setSpiritTags(button.getAttribute('data-spirit-tags') || '');
    setText(selectors.mobileSpiritPrice, button.getAttribute('data-spirit-price') || '');
    setText(selectors.mobileSpiritCompare, button.getAttribute('data-spirit-compare') || '');
  }

  function setSpiritDrawer(open) {
    document.querySelectorAll(selectors.spiritDrawer).forEach(function (drawer) {
      drawer.classList.toggle('is-open', open);
      drawer.setAttribute('aria-hidden', open ? 'false' : 'true');
      if (open) {
        drawer.scrollTop = 0;
        var list = drawer.querySelector('.starter-pack-spirit-list');
        if (list) {
          list.scrollTop = 0;
        }
      }
    });
    document.documentElement.classList.toggle('starter-pack-spirit-open', open);
    document.body.classList.toggle('starter-pack-spirit-open', open);
  }

  function updateSelectedButtons() {
    document.querySelectorAll(selectors.optionButtons).forEach(function (button) {
      var index = Number(button.getAttribute('data-option-index'));
      var value = button.getAttribute('data-option-value');
      button.setAttribute('aria-selected', state.options[index] === value ? 'true' : 'false');
    });
  }

  function updateOptionAvailability() {
    document.querySelectorAll(selectors.optionButtons).forEach(function (button) {
      var index = Number(button.getAttribute('data-option-index'));
      var value = button.getAttribute('data-option-value');
      var variant = variantForOption(index, value);
      var unavailable = !isPurchasableVariant(variant);
      var badge = button.querySelector('.starter-pack-choice__sold-out');

      button.classList.toggle('is-sold-out', unavailable);
      button.setAttribute('data-option-available', unavailable ? 'false' : 'true');

      if (unavailable && !badge) {
        badge = document.createElement('span');
        badge.className = 'starter-pack-choice__sold-out';
        badge.textContent = 'Sold out';
        button.appendChild(badge);
      } else if (!unavailable && badge) {
        badge.remove();
      }
    });
  }

  function updateEngravingField() {
    var field = document.querySelector(selectors.engravingField);
    if (!field) return;
    field.classList.toggle('is-visible', isEngravingSelected());
    field.setAttribute('aria-hidden', isEngravingSelected() ? 'false' : 'true');
  }

  function updateVariantUi() {
    state.selectedVariant = matchingVariant();
    updateSelectedButtons();
    updateOptionAvailability();
    updateEngravingField();

    var variant = state.selectedVariant;
    var hasVariant = Boolean(variant);
    var available = isPurchasableVariant(variant);
    var discountedPrice = hasVariant ? Math.max(0, variant.price - freeGiftDiscount) : 0;
    var baseVariant = matchingBaseVariant();
    var baseDiscountedPrice = baseVariant ? Math.max(0, baseVariant.price - freeGiftDiscount) : discountedPrice;
    var price = hasVariant ? money(discountedPrice) : copy.unavailablePriceLabel;
    var basePrice = hasVariant ? money(baseDiscountedPrice) : copy.unavailablePriceLabel;

    setText(selectors.price, price);
    setText(selectors.mobilePrice, price);
    setText(selectors.mobileSelection, state.options[0] || copy.mobileSpiritPlaceholder);
    setText(selectors.spiritSummary, state.options[0] || copy.mobileSpiritPlaceholder);
    setText(selectors.giftSummary, state.options[1] || '');
    setText(selectors.engravingSummary, isEngravingSelected() ? copy.engravingSelectedLabel : copy.engravingNotSelectedLabel);
    setText(selectors.spiritSummaryPrice, basePrice);
    setText(selectors.engravingSummaryPrice, isEngravingSelected() ? copy.engravingSelectedPriceLabel : copy.engravingNotSelectedPriceLabel);
    setText(selectors.availability, hasVariant ? (available ? '' : copy.soldOutText) : copy.unavailableText);
    document.querySelectorAll(selectors.savings).forEach(function (element) {
      element.textContent = element.getAttribute('data-starter-pack-savings-text') || '';
    });
    setSummaryImage(selectors.spiritSummaryMedia, selectedButton(0) && selectedButton(0).getAttribute('data-summary-image'), '<svg viewBox="0 0 24 24" focusable="false"><path d="M9 3h6"/><path d="M10 3v5l-2 3v8a2 2 0 0 0 2 2h4a2 2 0 0 0 2-2v-8l-2-3V3"/><path d="M9 13h6"/></svg>');
    setSummaryImage(selectors.giftSummaryMedia, selectedButton(1) && selectedButton(1).getAttribute('data-summary-image'), '<svg viewBox="0 0 24 24" focusable="false"><path d="M5 8h11v6.5A4.5 4.5 0 0 1 11.5 19h-2A4.5 4.5 0 0 1 5 14.5z"/><path d="M16 10h1.4a2.6 2.6 0 0 1 0 5.2H16"/></svg>');
    updateMobileSpiritTrigger();

    document.querySelectorAll(selectors.variantInput).forEach(function (input) {
      input.value = hasVariant ? variant.id : '';
    });

    document.querySelectorAll(selectors.comparePrice).forEach(function (element) {
      if (hasVariant) {
        element.textContent = money(variant.price);
        element.hidden = false;
      } else {
        element.hidden = true;
      }
    });

    setDisabled(selectors.addButton, !available || state.adding);
    setDisabled(selectors.mobileAddButton, !available || state.adding);
    setAddButtonState(state.adding);
  }

  function clearMessage() {
    setText(selectors.message, '');
  }

  function selectedGift() {
    return state.options[1] || '';
  }

  function selectedEngraving() {
    return state.options[2] || '';
  }

  function cartProperties() {
    var properties = {};
    properties[copy.freeGiftPropertyName] = selectedGift();
    properties[copy.giftBoxPropertyName] = giftBoxProperty;
    properties[copy.offerCodePropertyName] = copy.discountCode;
    properties[copy.engravingSelectedPropertyName] = selectedEngraving();

    if (isEngravingSelected() && state.engravingText) {
      properties[copy.engravingTextPropertyName] = state.engravingText;
    }

    return properties;
  }

  function addToCart() {
    if (!isPurchasableVariant(state.selectedVariant) || state.adding) return;

    state.adding = true;
    state.redirecting = false;
    clearMessage();
    updateVariantUi();

    var root = window.Shopify && window.Shopify.routes && window.Shopify.routes.root ? window.Shopify.routes.root : '/';
    var encodedDiscountCode = encodeURIComponent(copy.discountCode);
    var cartPath = root + 'cart?discount=' + encodedDiscountCode;
    var discountCartUrl = root + 'discount/' + encodedDiscountCode + '?redirect=' + encodeURIComponent(cartPath);

    fetch(root + 'cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({
        id: state.selectedVariant.id,
        quantity: 1,
        properties: cartProperties()
      })
    })
      .then(function (response) {
        if (!response.ok) {
          return response.json().then(function (data) {
            throw new Error(data.description || copy.errorLabel);
          });
        }
        return response.json();
      })
      .then(function () {
        state.redirecting = true;
        setText(selectors.message, copy.addedLabel);
        window.location.href = discountCartUrl;
      })
      .catch(function (error) {
        state.adding = false;
        setText(selectors.message, error.message || copy.errorLabel);
        updateVariantUi();
      })
      .finally(function () {
        if (state.redirecting) return;
        state.adding = false;
        updateVariantUi();
      });
  }

  document.addEventListener('click', function (event) {
    var optionButton = event.target.closest(selectors.optionButtons);
    if (optionButton) {
      var index = Number(optionButton.getAttribute('data-option-index'));
      state.options[index] = optionButton.getAttribute('data-option-value');
      clearMessage();
      updateVariantUi();
      if (index === 0) {
        setSpiritDrawer(false);
      }
      return;
    }

    if (event.target.closest(selectors.spiritOpen)) {
      setSpiritDrawer(true);
      return;
    }

    if (event.target.closest(selectors.spiritClose)) {
      setSpiritDrawer(false);
      return;
    }

    if (event.target.matches(selectors.spiritDrawer)) {
      setSpiritDrawer(false);
      return;
    }

    if (event.target.closest(selectors.mobileAddButton)) {
      clearMessage();
    }
  });

  document.addEventListener('input', function (event) {
    if (!event.target.matches(selectors.engravingText)) return;
    state.engravingText = event.target.value.trim();
    setText(selectors.engravingCount, String(event.target.value.length));
  });

  document.addEventListener('keydown', function (event) {
    if (event.key === 'Escape') {
      setSpiritDrawer(false);
    }
  });

  document.addEventListener('submit', function (event) {
    if (!event.target.matches(selectors.form)) return;
    event.preventDefault();
    addToCart();
  });

  updateVariantUi();
  preloadAllFeatureImages();
  }
  });
})();
